import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";

export class EntityPersistenceService {
    private static baseUrl: string = '/api/entity';

    static tags = {
        update: "update",
    }

    static updateField = (entityName: string, entityId: string, fieldName: string, fieldValue: any): Promise<any> => {
        return trackPromise(new Promise<any>((resolve, reject) => {
            http(`${this.baseUrl}/${entityName}/${entityId}/${fieldName}`).put<any>(fieldValue)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.update);
    };
}

// const batchDelay: number = 150;

// interface IRequest {
//     entityKey?: any;
//     entityName: string;
//     data: any;
// }

// interface IQueueItem {
//     [key: string]: any;
// }

// interface IFieldUpdateService {
//     withDisabled(action: () => void): void;
//     update(requestBody: IRequest): Promise<Response | void>;
//     insert(requestBody: IRequest): Promise<Response | void>;
//     delete(requestBody: IRequest): Promise<Response | void>;
// }

// class FieldUpdateService implements IFieldUpdateService {
//     private serviceBase: string = '/api/entity';
//     private disabled: boolean = false;

//     withDisabled(action: () => void): void {
//         this.disabled = true;
//         action();
//         this.disabled = false;
//     }

//     private async persistenceRequest(type: string, requestBody: IRequest): Promise<Response | void> {
//         if (this.disabled) return;

//         const payload = this.preparePayload(type, requestBody);
//         if (!payload) return;

//         try {
//             const response = await fetch(`${this.serviceBase}/batch`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(payload),
//             });
//             return response;
//         } catch (error) {
//             console.error('Error making persistence request:', error);
//             throw error;
//         }
//     }

//     update(requestBody: IRequest): Promise<Response | void> {
//         return this.persistenceRequest('update', requestBody);
//     }

//     insert(requestBody: IRequest): Promise<Response | void> {
//         return this.persistenceRequest('insert', requestBody);
//     }

//     delete(requestBody: IRequest): Promise<Response | void> {
//         return this.persistenceRequest('delete', requestBody);
//     }

//     private preparePayload(type: string, requestBody: IRequest): any | null {
//         let payload: any = {};

//         const entityKey = requestBody.entityKey;
//         const entityName = requestBody.entityName;

//         if (!_.isArray(entityKey)) {
//             console.error('Entity key is not an array');
//             return null;
//         }

//         let node: any = payload;

//         node = node[type] = node[type] || {};
//         node = node[entityName] = node[entityName] || (entityKey ? {} : []);

//         if (entityKey) {
//             node = node[entityKey] = node[entityKey] || {};
//         }

//         const data = requestBody.data;

//         if (_.isEmpty(data)) {
//             return null;
//         }

//         if (_.isArray(node)) {
//             node.push(data);
//         } else {
//             _.extend(node, data);
//         }

//         return payload;
//     }
// }

// export default FieldUpdateService;
